



















import { Prop, Component, Vue } from "vue-property-decorator";
import ChartBar from "@/models/chart-bar";
import VBar from "./VBar.vue";
import VBarHandleLeft from "./VBarHandleLeft.vue";
import VBarHandleRight from "./VBarHandleRight.vue";

@Component({
  components: {
    VBar,
    VBarHandleLeft,
    VBarHandleRight
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
})
export default class VChartBar extends Vue {
  @Prop({ required: true }) bar!: ChartBar;
  @Prop({ required: true }) readonly!: boolean;

  get cursor() {
    if (this.readonly) {
      return "pointer";
    } else {
      return "move";
    }
  }

  click(e: MouseEvent) {
    this.$emit("click", e);
  }

  clickBar(e: MouseEvent) {
    if (!this.readonly) return;
    this.$emit("click", e);
  }

  movestart(e: MouseEvent) {
    if (this.readonly) return;
    this.$emit("movestart", e);
  }

  shrinkstart(e: MouseEvent) {
    if (this.readonly) return;
    this.$emit("shrinkstart", e);
  }

  expandstart(e: MouseEvent) {
    if (this.readonly) return;
    this.$emit("expandstart", e);
  }
}
